
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/view-base/abpbase'
import { RoleDto, UpdateUserRoleInput } from '@/api/service-proxies'

import { userService } from '@/api/userService'
import { ElForm } from 'element-ui/types/form'

@Component({
  name: 'select-record-face-templete',
  components: {},
})
export default class UpdateVip extends AbpBase {
  @Prop({ type: Boolean, default: false }) value!: boolean

  form = {
    vipType: 0,
    expireDate: '',
    updateType:"0"
  }

  rules = {
    vipType: { required: true, message: '请选择会员类型', trigger: 'blur' },
    expireDate: { required: true, message: '请选择到期时间', trigger: 'blur' },
  }

  @Watch('value')
  watchValue() {
    if (this.isDialogVisible) {
    }
  }

  get isDialogVisible() {
     this.form.updateType="0";
    return this.value
  }

  set isDialogVisible(value: boolean) {
    this.$emit('input', value)
  }

  created() {}

  async done() {
    ;(this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        this.$emit('input', false)
        this.$emit('onSuccess', this.form)
      }
    })
  }
}
